import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.65, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="18" fill="#FF6B00" />
    <circle cx="32" cy="32" r="19" fill="none" stroke="#fff" strokeOpacity="0.55" strokeWidth="4" />
    <circle cx="32" cy="32" r="9" fill="#fff" />
  </svg>
);

export const Wordmark = ({ dark = false }) => (
  <span
    className={`font-heading text-2xl font-extrabold tracking-tight ${
      dark ? "text-white" : "text-tracksy-ink"
    }`}
  >
    tracksy<span className="text-tracksy-orange">.</span>
  </span>
);
